import React, { useState, useEffect } from 'react';
import { GET, DELETE } from '../../../helpers/httphelper';
import PersonalArticle from '../components/PersonalArticle';
import ReadArticle from '../components/ReadArticle';
import { toast as superToast } from 'bulma-toast';
import { Link } from 'react-router-dom';

function PersonalArticles() {
  const [articles, setArticles] = useState([]);
  const [change, setChange] = useState(true);
  const [readTrigger, setReadTrigger] = useState(false);
  const [article, setArticle] = useState({});

  const handlePopup = (data) => {
    setArticle(data);
    console.log(article)
    setReadTrigger(true);
  }

  useEffect(() => {
    const getArticles = async () => {
      try {
        if (localStorage.getItem('user')) {
          const res = await GET(`api/articles/get/user/${localStorage.getItem('user')}`);
          setArticles(res.data);
          console.log(res.data);
        }
      } catch (err) {
        console.log(err);
      }
    }
    getArticles();
  }, [change]);

  const handleDeleteArticle = async (id) => {
    try {
      const res = await DELETE(`api/articles/delete/${id}`);
      console.log(res);
      setChange(!change);
      superToast({
        message: res.message,
        type: 'is-success',
        dismissible: true,
        position: "top-center",
        animate: { in: 'fadeIn', out: 'fadeOut' },
      })
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="container">
      <Link to="../articles"><h1 className='has-text-left mt-3'><i class="fas fa-arrow-circle-left"></i></h1></Link>
      <p className='title is-size-3-mobile is-1 mt-2 has-text-centered mt-5'>My Articles</p>
      <p className='title is-4'>Article Count = {articles?.length}</p>
      <div className="columns">
        <div className="column is-12">
          {articles?.map((item, index) => (
            <div className="box" key={index}>
              <PersonalArticle data={item} handleDeleteArticle={handleDeleteArticle} handlePopup={handlePopup} />
            </div>
          ))}
        </div>
      </div>
      <ReadArticle readTrigger={readTrigger} setReadTrigger={setReadTrigger} data={article} />
    </div>
  )
}

export default PersonalArticles;